module.exports = {"510681100":"雒城镇","510681101":"三水镇","510681102":"连山镇","510681103":"高坪镇","510681104":"南兴镇","510681105":"向阳镇","510681106":"小汉镇","510681107":"金轮镇","510681108":"新丰镇","510681109":"兴隆镇","510681112":"和兴镇","510681113":"松林镇","510681114":"金鱼镇","510681115":"新平镇","510681116":"南丰镇","510681119":"西高镇","510681200":"北外乡","510681202":"西外乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510681.json
// module id = 2297
// module chunks = 0